import { IModal } from "libraries/WorkflowFramework/Interfaces/IModal";
import { IWorkflowModuleModalInstance } from "libraries/WorkflowFramework/Interfaces/IWorkflowModule";
import { AnalysisModulePreset, AnalysisPreset, AnalysisPresetType, AnalysisPresets } from "./AnalysisPresets";

export class AnalysisModal implements IModal<AnalysisPresetModalReturnState> {
    private modalInstance: IWorkflowModuleModalInstance<AnalysisPresetModalReturnState>;
    private selectedPreset: AnalysisPreset;

    private analysisPresets: AnalysisPreset[] = [
        {
            name: "bearingspreset",
            type: "mechanical",
            title: "Bearings, gearboxes, axes and belts",
            icon: "fas fa-cogs",
            analysisModulePresets: AnalysisPresets.BearingModulePresets,
        },
        {
            name: "pumpspreset",
            type: "mechanical",
            title: "Pumps",
            icon: "fas fa-gas-pump",
            analysisModulePresets: AnalysisPresets.PumpsModulePresets,
        },
        {
            name: "leakspreset",
            type: "leak",
            title: "Gas leaks",
            icon: "fas fa-wind",
            analysisModulePresets: AnalysisPresets.LeaksModulePresets,
        },
        {
            name: "partialdischargepreset",
            type: "partialDischarge",
            title: "Partial discharge",
            icon: "fas fa-bolt",
            analysisModulePresets: AnalysisPresets.PartialDischargeModulePresets,
        },
    ];

    constructor() {}

    public activateModal(
        state: unknown,
        modalInstance: IWorkflowModuleModalInstance<AnalysisPresetModalReturnState>
    ): void {
        this.modalInstance = modalInstance;
    }

    public close(): AnalysisPresetModalReturnState {
        return <AnalysisPresetModalReturnState>{
            analysisType: this.selectedPreset.type,
            selectedAnalysisModulePresets: this.selectedPreset.analysisModulePresets,
        };
    }

    public select(preset: AnalysisPreset) {
        this.selectedPreset = preset;
        this.modalInstance.close();
    }
}

export class AnalysisPresetModalReturnState {
    public analysisType: AnalysisPresetType;
    public selectedAnalysisModulePresets: AnalysisModulePreset[];
}
